import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    user: {},
    token: "",
    pagePermission: {},
    fancyCounter: {},
    bookmakerCounter: {},
    parentIdList: [],
  },
  reducers: {
    updateUser(state, action) {
      state.user = action.payload;
    },
    setToken(state, action) {
      state.token = action.payload;
    },
    clearUser(state) {
      state.user = {};
      state.token = "";
      state.pagePermission = {};
    },
    setPagePermissions(state, action) {
      state.pagePermission = action.payload;
    },
    setFancyCounter(state, action) {
      state.fancyCounter = action.payload;
    },
    setBookmakerCounter(state, action) {
      state.bookmakerCounter = action.payload;
    },
    setParentIdList(state, action) {
      state.parentIdList = action.payload;
    },
    clearParentIdList(state) {
      state.parentIdList = [];
    },
  },
});

export const userAction = userSlice.actions;
export default userSlice;
